import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasicMixin.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BasicMixin.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/mixins/BasicMixin.vue?vue&type=script&lang=js&
// module id = OLZ2
// module chunks = 33